/* tslint:disable */
/* eslint-disable */
/**
 * FileManagement API
 * This is an OpenAPI for the FileManagement Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface FileBody
 */
export interface FileBody {
    /**
     * 
     * @type {string}
     * @memberof FileBody
     */
    Type: FileBodyTypeEnum;
    /**
     * 
     * @type {Blob}
     * @memberof FileBody
     */
    File: Blob;
}

/**
    * @export
    * @enum {string}
    */
export enum FileBodyTypeEnum {
    TENANTLOGO = 'TENANT_LOGO',
    USERIDENTITYIMAGE = 'USER_IDENTITY_IMAGE',
    PROFILEPICTURE = 'PROFILE_PICTURE',
    INSURANCEID = 'INSURANCE_ID',
    PRESCRIPTIONIMAGE = 'PRESCRIPTION_IMAGE',
    EXTERNALARCHIVE = 'EXTERNAL_ARCHIVE',
    TESTRESULTIMAGE = 'TEST_RESULT_IMAGE',
    INVOICEIMAGE = 'INVOICE_IMAGE'
}

